import { render } from "./section3-graf.vue?vue&type=template&id=3b779c04&scoped=true"
const script = {}

import "./section3-graf.vue?vue&type=style&index=0&id=3b779c04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b779c04"]])

export default __exports__